import React, { useState } from 'react'
import Layout from '../layout/Layout'
import { useParams } from 'react-router-dom';
import Button from '../components/AddFolder/Button';
import Message from '../components/common/Message';
import secureApi from '../helpers/secureApi';
import axios from 'axios';

export default function AddDoc() {

    const {id, folderId} = useParams();
    const [name, setName] = useState('');
    const [detail, setDetail] = useState<string>('');
    const [file, setFile] = useState<File | null>(null);
    const [msg, setMsg] = useState('');
    const [disable, setDisable] = useState(false);

    const changeFile = (e: React.ChangeEvent<HTMLInputElement>)=>{
        console.log("e", e.target.files);
        if(e?.target?.files?.[0]){
            setFile(e?.target?.files?.[0]);
        }
    }

    const resetForm = ()=>{
        setName('');
        setDetail('');
        setFile(null);
    }

    const saveDoc = async (e: React.FormEvent<HTMLFormElement>)=>{
        try{
            e.preventDefault();
            setMsg('');
            setDisable(true);
            if(name && file && folderId){
                let api = secureApi('add-doc');
                if(id){
                    api = secureApi('update-doc');
                }
                if(api){
                    const formData = new FormData();
                    formData.append('file', file);
                    formData.append('name', name);
                    formData.append('detail', detail);
                    formData.append('folder_id', folderId);
                    if(id){
                        formData.append('id', id);
                    }
                    const response = await axios.post(api, formData, {
                        headers: {
                          'Content-Type': 'multipart/form-data',
                        },
                    });
                    if(response?.data?.content?.name){
                      setMsg('Record has been saved');
                      resetForm();
                    }
                    console.log("response", response);
                  }
                  else{
                    console.log("saveDoc, api not found");
                }
            }
            else{
                console.log("name, folderId and file is required")
            }
        }
        catch(e){
            console.log("saveDoc error", e);
        }
        finally{
            setDisable(false);
        }
    }
    
  return (
    <Layout>
        <div className='formWrap'>
            <div><h1>{id ? 'Edit' : 'Add'} Doc</h1></div>
            <form onSubmit={saveDoc}>
                <input value={name} type="text" placeholder='Name...' onChange={(e:React.ChangeEvent<HTMLInputElement>)=>setName(e.target.value)} />
                <input type="file" onChange={changeFile} />
                <textarea value={detail} rows={5} cols={50} onChange={(e)=> setDetail(e.target.value)} />
                <Button id={id} name={name} disabled={disable} />
            </form>
            <Message msg={msg} />
        </div>
    </Layout>
  )
}
